/* tslint:disable */
/* eslint-disable */
/**
 * Local Map - Local Map Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.3
 * Contact: local-map@daangn.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../../../runtime';
import type { V1UserProfile } from './V1UserProfile';
import {
    V1UserProfileFromJSON,
    V1UserProfileFromJSONTyped,
    V1UserProfileToJSON,
} from './V1UserProfile';

/**
 * 
 * @export
 * @interface V1GetUserProfileResponse
 */
export interface V1GetUserProfileResponse {
    /**
     * 
     * @type {V1UserProfile}
     * @memberof V1GetUserProfileResponse
     */
    userProfile: V1UserProfile;
}

/**
 * Check if a given object implements the V1GetUserProfileResponse interface.
 */
export function instanceOfV1GetUserProfileResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "userProfile" in value;

    return isInstance;
}

export function V1GetUserProfileResponseFromJSON(json: any): V1GetUserProfileResponse {
    return V1GetUserProfileResponseFromJSONTyped(json, false);
}

export function V1GetUserProfileResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): V1GetUserProfileResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userProfile': V1UserProfileFromJSON(json['user_profile']),
    };
}

export function V1GetUserProfileResponseToJSON(value?: V1GetUserProfileResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user_profile': V1UserProfileToJSON(value.userProfile),
    };
}

